module.exports = __webpack_public_path__ + "static/img/border2_topl.5ae85250.png";